// import {checkPower} from '@/assets/service/App';
// import {SET_PROJECT_INFO} from './mutation-types.js';
import HomeService from '@/assets/service/home'
export default {
  // async checkPowerValidate({commit, state}, router) {
  //   return new Promise((resolve, reject) => {
  //     checkPower({router}).then(res => {
  //       commit(SET_PROJECT_INFO, res);
  //       resolve(res);
  //     }).catch(err => {
  //       reject(err);
  //     });
  //   });
  // }
  async getUserInfo (){
    return new Promise((resolve, reject) => {
      HomeService.getUserInfo().then(res => {
        resolve(res)
      }).catch(() => {
      })
    })
  }
}

